// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"image-1"},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M13.5 17L9 10L2 21H22L16 13L13.5 17Z"},"nodeName":"path","children":[]},{"attributes":{"id":"fill2","cx":17,"cy":6,"r":3,"fill":"transparent"},"nodeName":"circle","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M13.5 17L9 10L2 21H22L16 13L13.5 17Z","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke2","cx":17,"cy":6,"r":3,"stroke":"currentColor","stroke-width":2},"nodeName":"circle","children":[]}]}]};

@tag('t-icon-image-1')
export default class Image1Icon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'image-1',
    }
  }
}
